import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { CircularGauge } from "@progress/kendo-react-gauges";
import { Loader } from "@progress/kendo-react-indicators";
import { useLocalization } from "@progress/kendo-react-intl";
import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { AccessToken } from "../../config/AccessToken";

export const BeaconsTileCounter = () => {
    const SERVER_URL = process.env.REACT_APP_SERVER_URL;
    const [instance, accessTokenRequest] = AccessToken();
    const localizationService = useLocalization();
    const languageId = localStorage.getItem("languageId");

    const [counterBeacons, setCounterBeacons] = useState<number>(0);
    const [loading, setLoading] = useState<boolean>(false);
    const hasFetchedBeaconCounterRef = useRef(false);

    useEffect(() => {
        if (hasFetchedBeaconCounterRef.current) {
            return;
        }

        hasFetchedBeaconCounterRef.current = true;

        const getBeaconCounter = async () => {
            setLoading(true);

            const commonOperations = async (accessToken: any) => {
                const headers = { Authorization: `Bearer ${accessToken}`, Language: languageId };
                const params = { enabled: true };

                try {
                    const res = await axios.get(`${SERVER_URL}/beacon/count`, { headers, params });
                    const data = res?.data?.data ?? 0;
                    setCounterBeacons(data);
                } catch {
                    setCounterBeacons(0);
                } 
                setLoading(false);
            };

            if (localStorage.getItem("accessToken") != null) {
                const accessToken = localStorage.getItem("accessToken");
                await commonOperations(accessToken);
            } else {
                await instance.initialize();
                await instance.acquireTokenSilent(accessTokenRequest)
                    .then((accessTokenResponse: any) => {
                        const accessToken = accessTokenResponse.accessToken;
                        return commonOperations(accessToken);
                    })
                    .catch((error: any) => {
                        if (error instanceof InteractionRequiredAuthError) {
                            instance.acquireTokenRedirect(accessTokenRequest);
                        }
                        setLoading(false);
                    });
            }
        };

        void getBeaconCounter();
    }, [SERVER_URL, instance, accessTokenRequest, languageId]);

    return (
        <div style={{ zoom: '65%' }}>
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%', position: 'relative', top: '30px' }}>
                <CircularGauge
                    value={Number(counterBeacons ?? 0)}
                    transitions={false}
                    arcCenterRender={() => (
                        <h3 style={{ fontSize: "1.5cqw", fontWeight: "bold", color: "#198894" }}>
                            {loading ? <Loader size="small" type="infinite-spinner" themeColor="primary" /> : counterBeacons ?? 0}
                        </h3>
                    )}
                    style={{ height: "120px" }}
                    color="#F2994A"
                    scale={{
                        startAngle: 90,
                    }}
                />
            </div>
            <h4
                style={{
                    fontSize: '20px',
                    color: '#666666',
                    textAlign: 'center',
                    minHeight: '24px',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    position: 'relative',
                    top: '30px'
                }}
            >
                {localizationService.toLanguageString("beacons.total", "NOT_FOUND")}

            </h4>
        </div>
    );
};